export default __webpack_public_path__ + "static/monitoring_img-2879d3c77b82a96e8065ab29857b932f.png";